import React, { useEffect, useState, useCallback } from "react";
import Button from "../../Components/Button";
import EmailBlastForm from "../../Components/EmailBlastForm";
import LoadingInComponent from "../../Components/LoadingInComponent";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  GET_EMAIL_TEMPLATE_DETAILS_API,
  UPDATE_EMAIL_TEMPLATE_API,
} from "../../Constant/api";
import { useToast } from "../../Components/Toast";
import { MESSAGE_BLAST, MESSAGE_BLAST_PREVIEW } from "../../Router/path";
import EmailGuide from "../../Components/EmailGuide";
import Breadcrumb from "../../Components/Breadcrumb";
import WhatsappBlastForm from "../../Components/WhatsappBlastForm";

const MessageBlastEdit = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [templateName, setTemplateName] = useState("");
  const [resetKey, setResetKey] = useState(0); // Add a key state

  const { toast } = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const recordId = location.state.recordId;
  const type = location.state.type;
  const stateData = location.state.data ?? "";

  const handleChange = (e) => {
    setNewFormData({ ...newFormData, [e.target.name]: e.target.value });
  };

  const handleReset = () => {
    const resetFormData = JSON.parse(JSON.stringify(formData));
    setNewFormData(resetFormData);
    setResetKey((prevKey) => prevKey + 1);
  };

  const handleUpdate = () => {
    setLoading(true);
    try {
      axios
        .put(UPDATE_EMAIL_TEMPLATE_API, newFormData, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
          },
        })
        .then((res) => {
          setLoading(false);
          navigate(MESSAGE_BLAST, { state: { type: type } });
          toast(
            `${
              type === "email" ? "Email" : "WhatsApp"
            } template updated successfully`,
            "success"
          );
        })
        .catch((error) => {
          setLoading(false);
          console.error(error);
          toast(
            `Failed to update ${
              type === "email" ? "email" : "WhatsApp"
            } template`,
            "error"
          );
        });
    } catch (error) {
      console.error(error);
      toast(
        `Failed to update ${type === "email" ? "email" : "WhatsApp"} template`,
        "error"
      );
    }
  };

  const fetchEmailTemplateRecord = useCallback(async () => {
    setLoading(true);
    try {
      axios
        .get(GET_EMAIL_TEMPLATE_DETAILS_API, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
          },
          params: { templateId: recordId },
        })
        .then((res) => {
          const fetchedData = res.data.data;
          setFormData(fetchedData);
          setNewFormData({ ...fetchedData });
          setTemplateName(fetchedData.name);
          // setEmailTemplateName(fetchedData.name);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.error(error);
          toast("Failed to fetch email template record", "error");
        });
    } catch (error) {
      console.error(error);
      toast("Failed to fetch email template record", "error");
    }
  }, [recordId, toast]);

  useEffect(() => {
    fetchEmailTemplateRecord();
  }, [fetchEmailTemplateRecord]);

  const breadcrumbItems = [
    { label: "Message Blast", to: "/message-blast" },
    { label: type === "email" ? "Email Template" : "WhatsApp Template" },
    { label: templateName || "Template" },
    { label: "Edit" },
  ];

  const handlePreview = () => {
    navigate(MESSAGE_BLAST_PREVIEW, {
      state: { data: newFormData, recordId: recordId, type: type },
    });
  };

  useEffect(() => {
    if (stateData) {
      setNewFormData(stateData);
    } else {
      setNewFormData(formData);
    }
  }, [stateData, formData]);

  return (
    <div className="flex flex-col w-full h-full">
      <LoadingInComponent isLoading={loading}>
        {!loading && (
          <div className="flex flex-col w-full h-full">
            <div className="flex flex-col w-full h-full p-[16px] md:p-[32px] no-scrollbar overflow-y-auto gap-[12px] md:gap-[24px]">
              {/* Breadcrumb */}
              <Breadcrumb items={breadcrumbItems} />

              {/* Title row */}
              <div className="flex w-full justify-between items-center">
                <h1 className="text-[29px]">Edit</h1>
                <div className="flex gap-[8px]">
                  <Button variant="secondary" onClick={handlePreview}>
                    Preview
                  </Button>
                  {/* <Button variant="primary">
                    <Send2 size="16" variant="Bold" />
                    Send Email
                  </Button> */}
                </div>
              </div>

              {/* Guide */}
              <EmailGuide />

              {/* Form */}
              {formData && newFormData && type === "email" ? (
                <div className="w-full">
                  <EmailBlastForm
                    key={resetKey}
                    formData={newFormData}
                    handleChange={handleChange}
                  />
                </div>
              ) : (
                <WhatsappBlastForm
                  key={resetKey}
                  formData={newFormData}
                  handleChange={handleChange}
                />
              )}

              {/* Button */}
              <div className="flex w-full gap-[8px] items-center">
                <Button variant="primary" onClick={handleUpdate}>
                  Save
                </Button>
                <Button variant="secondary" onClick={handleReset}>
                  Reset Template
                </Button>
                <Button
                  variant="secondary"
                  onClick={() =>
                    navigate(MESSAGE_BLAST, {
                      state: { type: type },
                    })
                  }
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        )}
      </LoadingInComponent>
    </div>
  );
};

export default MessageBlastEdit;
